import React from 'react';
import { Card, CardContent } from '../ui/card';
import { MapPin, Calendar, Users, Car } from 'lucide-react';

const OrderSummary = ({ bookingDetails }) => {
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    return date.toLocaleDateString('en-GB', { weekday: 'short', day: 'numeric', month: 'short' });
  };

  return (
    <Card className="bg-card text-card-foreground border-0 shadow-lg overflow-hidden">
      {/* Orange top accent line - Lane motif */}
      <div className="h-1 bg-primary" />
      
      <CardContent className="p-6">
        <h3 className="font-display text-lg font-bold text-card-foreground mb-6">
          Order Summary
        </h3>

        {/* Trip Details */}
        <div className="space-y-4 mb-6">
          <div className="flex items-start gap-3">
            <MapPin className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
            <div className="text-sm flex-1">
              <p className="text-muted-foreground text-xs uppercase tracking-wider mb-0.5">Pickup</p>
              <p className="text-card-foreground font-medium">{bookingDetails.pickup}</p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <MapPin className="h-4 w-4 text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="text-sm flex-1">
              <p className="text-muted-foreground text-xs uppercase tracking-wider mb-0.5">Drop-off</p>
              <p className="text-card-foreground font-medium">{bookingDetails.dropoff}</p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <Calendar className="h-4 w-4 text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="text-sm flex-1">
              <p className="text-muted-foreground text-xs uppercase tracking-wider mb-0.5">Date & Time</p>
              <p className="text-card-foreground font-medium">
                {formatDate(bookingDetails.date)} at {bookingDetails.time}
              </p>
            </div>
          </div>
          
          <div className="flex items-start gap-3">
            <Users className="h-4 w-4 text-muted-foreground mt-0.5 flex-shrink-0" />
            <div className="text-sm flex-1">
              <p className="text-muted-foreground text-xs uppercase tracking-wider mb-0.5">Passengers</p>
              <p className="text-card-foreground font-medium">{bookingDetails.passengers}</p>
            </div>
          </div>
        </div>

        {/* Divider */}
        <div className="border-t border-border my-4" />

        {/* Selected Vehicle */}
        <div className="flex items-start gap-3 mb-6">
          <Car className="h-4 w-4 text-primary mt-0.5 flex-shrink-0" />
          <div className="text-sm flex-1">
            <p className="text-muted-foreground text-xs uppercase tracking-wider mb-0.5">Vehicle</p>
            <p className="text-card-foreground font-semibold">{bookingDetails.vehicleName}</p>
            <p className="text-muted-foreground text-xs">{bookingDetails.vehicleDesc}</p>
          </div>
        </div>

        {/* Total Price */}
        <div className="bg-muted/30 rounded-lg p-4">
          <div className="flex items-center justify-between">
            <span className="text-card-foreground font-medium">Total</span>
            <div className="text-right">
              <div className="flex items-baseline gap-1">
                <span className="text-sm text-muted-foreground">{bookingDetails.currency}</span>
                <span className="font-display text-3xl font-bold text-card-foreground">
                  {bookingDetails.price}
                </span>
              </div>
            </div>
          </div>
          <p className="text-xs text-primary mt-1 text-right">Fixed price · No hidden fees</p>
        </div>
      </CardContent>
      
      {/* Orange bottom accent line */}
      <div className="h-0.5 bg-primary/30" />
    </Card>
  );
};

export default OrderSummary;
